export class Dimensions {
    width: number;
    height: number;

    constructor(width: number, height: number) {
        this.width = width;
        this.height = height
    }
}